function toggleVideoSound(card, event) {
  // 1. Prevent trigger if clicking the Add to Cart button or form
  if (event.target.closest('form') || event.target.closest('.vid-add-btn')) return;

  var video = card.querySelector('video');
  var iconMuted = card.querySelector('.icon-muted');
  var iconUnmuted = card.querySelector('.icon-unmuted');

  if (!video) return;

  // 2. Logic: If we are about to UNMUTE this video (currently muted)
  if (video.muted) {
    
    // A. Find all other video cards and MUTE them first
    var allCards = document.querySelectorAll('.vid-card');
    allCards.forEach(function(otherCard) {
      if (otherCard === card) return; // Skip the one we just clicked

      var otherVideo = otherCard.querySelector('video');
      var otherIconMuted = otherCard.querySelector('.icon-muted');
      var otherIconUnmuted = otherCard.querySelector('.icon-unmuted');

      if (otherVideo) {
        otherVideo.muted = true;
        if (otherIconMuted) otherIconMuted.style.display = 'block';
        if (otherIconUnmuted) otherIconUnmuted.style.display = 'none';
      }
    });

    // B. Now Unmute the clicked video
    video.muted = false;
    iconMuted.style.display = 'none';
    iconUnmuted.style.display = 'block';

  } else {
    // 3. If we are clicking to MUTE the video
    video.muted = true;
    iconMuted.style.display = 'block';
    iconUnmuted.style.display = 'none';
  }
}



document.addEventListener("DOMContentLoaded", function() {
  // Select images from both the Tan Gallery and Why Benefits grid
  var clickableImages = document.querySelectorAll('.tan-gallery-item img, .why-icon-wrap img');

  clickableImages.forEach(function(img) {
    img.addEventListener('click', function() {
      var modal = document.getElementById('image-modal');
      var modalImg = document.getElementById('modal-img');
      
      // Show modal and set image source
      modal.style.display = "flex";
      modalImg.src = this.src; // Uses the src of the clicked image
      
      // Disable scrolling on the main page while modal is open
      document.body.style.overflow = "hidden";
    });
  });
});

function closeImageModal(event) {
  // Close only if clicking the Overlay (background) or the Close Button (X)
  if (event.target.classList.contains('image-modal-overlay') || 
      event.target.classList.contains('image-modal-close')) {
    
    var modal = document.getElementById('image-modal');
    modal.style.display = "none";
    
    // Re-enable scrolling
    document.body.style.overflow = "auto";
  }
}


function toggleKbgAccordion(button) {
  // 1. Identify the clicked item
  var clickedItem = button.closest('.kbg-accordion-item');
  
  // 2. Select ALL accordion items
  var allItems = document.querySelectorAll('.kbg-accordion-item');

  // 3. Loop through all items
  allItems.forEach(function(item) {
    // If this is the item we clicked...
    if (item === clickedItem) {
      // Toggle it (Open if closed, Close if open)
      item.classList.toggle('active');
    } else {
      // If this is NOT the clicked item, force it closed
      item.classList.remove('active');
    }
  });
}